/* eslint max-classes-per-file: 0 */
import { FsAccordion, FsAccordionItem } from '@cof/fs-accordion-wc/fs-accordion';

export class EsignAccordion extends FsAccordion {}

export class EsignAccordionItem extends FsAccordionItem {}

customElements.define('esign-accordion', EsignAccordion);
customElements.define('esign-accordion-item', EsignAccordionItem);
